module.exports = new __parcel__URL__("board-preview-dark.ba6ae5d7.svg").toString();